export default "__VITE_ASSET__78aa950b__"